import { useEffect, useState } from "react";
import { opcionesPorOperacion } from "../../configs/constants";
import { getUser } from "../../auth";
import UpdateStock from "../../Stock/containers/UpdateStock.jsx"
import ActivityEditForm from "../components/ActivityEditForm";

const URL = process.env.REACT_APP_API_URL;
const user = getUser();

export default function ActivityEdit({ empresaNombre, empresa, selectedActivity, onUpdate, onClose }) {
  const [form, setForm] = useState({ title: "", operation: "", description: "", amount: "" });
  const [openStockModal, setOpenStockModal] = useState(false);

  useEffect(() => {
    if (selectedActivity) {
      setForm({
        title: selectedActivity.title,
        operation: selectedActivity.operation,
        description: selectedActivity.description || "",
        amount: selectedActivity.amount,
      });
    }
  }, [selectedActivity]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
      ...(name === "operation" ? { title: "" } : {}), // Reinicia title si cambia operation
    }));
  };

  const handleSubmit = () => {
    fetch(`${URL}/api/activity/${selectedActivity.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Empresa-Id": user?.empresa_id,
      },
      body: JSON.stringify(form),
    })
      .then(() => {
        onUpdate();
        onClose();
      })
      .catch((err) => console.error("Error updating activity:", err));
  };

  return (
    <>
      <ActivityEditForm
        empresaNombre={empresaNombre}
        empresa={empresa}
        form={form}
        onChange={handleChange}
        onSubmit={handleSubmit}
        selectedActivity={selectedActivity}
        opcionesPorOperacion={opcionesPorOperacion}
        onOpenStock={() => setOpenStockModal(true)}
      />

      <UpdateStock
        open={openStockModal}
        close={() => setOpenStockModal(false)}
      />
    </>
  );
}
